import {
  endpoints,
  EventInterfaces,
  EventTypes,
  sendEvent as sendEventToTracker
} from "@comparaonline/event-tracker";

import config from "../../../../config/app";

const { appName, appVersion } = config;

export interface IBusinessUnit {
  countryCode: string;
  businessUnit: string;
}

const appConfig = {
  appName,
  appVersion
};

const buildEvent = (event: any) => ({
  ...appConfig,
  ...event
});

const sendEvent = (eventData: EventInterfaces.FormStepRender) => {
  sendEventToTracker(endpoints.SNOWPLOW_APP, eventData);
};

type StepRenderData = {
  formId: string;
  formType: EventInterfaces.FormTypes;
} & Record<string, any>;

export const formStepRenderEvent = (businessUnit: IBusinessUnit) => ({
  formId,
  formType,
  ...eventProps
}: StepRenderData) => {
  const wizardFormProps = eventProps.formProps ? eventProps.formProps : eventProps;

  const { currentStep, stepsHistory, stepManagerProps, formApi } = wizardFormProps;
  const currentStepId = !stepManagerProps ? currentStep.id : stepManagerProps.steps[0].id;

  let values = wizardFormProps.values ? wizardFormProps.values : formApi.getState().values;

  if (eventProps.transformValues) {
    values = eventProps.transformValues(values);
  }

  const event = buildEvent({
    ...businessUnit,
    eventName: EventTypes.formStepRender,
    formId,
    formPreviousStepValue: values,
    formStepCount: stepsHistory.length + 1,
    formStepId: currentStepId,
    formStepName: currentStepId,
    formType
  });

  sendEvent(event);
};

export const sendFormSubmitEvent = (businessUnit: IBusinessUnit) => (
  formId: string,
  formValues: any,
  formStatus: "SUCCESS" | "FAILURE",
  formType: EventInterfaces.FormTypes
) => {
  const event = {
    ...businessUnit,
    eventName: EventTypes.formSubmit,
    formId,
    formStatus,
    formType,
    formValues
  };
  sendEvent(buildEvent(event));
};
